import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { lovable } from "@/integrations/lovable/index";
import { useToast } from "@/hooks/use-toast";

const AppleSignInButton = ({ label = "Continue with Apple" }: { label?: string }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleAppleSignIn = async () => {
    setIsLoading(true);
    try {
      const result = await lovable.auth.signInWithOAuth("apple", {
        redirect_uri: window.location.origin,
      });

      if (result.error) {
        toast({ title: "Sign in failed", description: String(result.error), variant: "destructive" });
        setIsLoading(false);
        return;
      }

      if (result.redirected) return;

      navigate("/dashboard");
    } catch {
      toast({ title: "Sign in failed", description: "Something went wrong.", variant: "destructive" });
      setIsLoading(false);
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      className="w-full gap-2"
      onClick={handleAppleSignIn}
      disabled={isLoading}
    >
      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.537 14.41c-.353.812-.522 1.175-.975 1.897-.632.998-1.524 2.24-2.63 2.25-1.104.013-1.388-.716-2.888-.706-1.5.008-1.812.722-2.916.709-1.105-.012-1.944-1.133-2.576-2.131C2.143 14.278 1.72 11.644 2.81 9.786c.774-1.315 2.034-2.095 3.198-2.095 1.19 0 1.94.72 2.923.72.956 0 1.538-.721 2.917-.721 1.035 0 2.153.563 2.925 1.535-2.568 1.41-2.152 5.081.764 6.185zM11.408 5.77c.487-.625.856-1.508.72-2.41-.795.055-1.726.56-2.27 1.222-.493.601-.9 1.496-.742 2.362.867.027 1.764-.49 2.292-1.174z" fill="currentColor"/>
      </svg>
      {isLoading ? "Connecting..." : label}
    </Button>
  );
};

export default AppleSignInButton;